import { Pipe, PipeTransform } from '@angular/core';
import { ReferenceArea } from '../../reference-areas/models/reference-area';

@Pipe({
  name: 'filterSatellite'
})
export class FilterSatellitePipe implements PipeTransform {

  transform(linkName: string): string {
    return linkName.replace('SATELLITE', 'ETH');
  }

}
